import { render, staticRenderFns } from "./iade.vue?vue&type=template&id=292be85d&scoped=true&"
import script from "./iade.vue?vue&type=script&lang=js&"
export * from "./iade.vue?vue&type=script&lang=js&"
import style0 from "./iade.vue?vue&type=style&index=0&id=292be85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292be85d",
  null
  
)

export default component.exports